import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { faEdit, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import saveAs from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { breadcrumb, link } from 'src/app/admin/layout/header/header.component';

import pptxgen from "pptxgenjs";


@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
})
export class ViewComponent {
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  maxDate = new Date();
  preloader: boolean = true;

  kLibrary: any[] = [];
  cat_items: any[] = [];
  filterCategories: any[] = []
  ous: any[] = [];
  staticURL = GlobalConstants.staticFilesURL;
  showDownload: boolean = false;
  selectedItem: any = {};
  selectedLink: any = {};
  currentCategory: any;
  categoryCount: any = {};
  availableExtensions: any[] = [];
  viewaslist: boolean = false;
  availableOus: any[] = [];

  filteredData: any = [];
  filterApplied = false;

  //Used to combile category filter with other filters, it will store data  to reset for category filter
  filteredState: any[] = [];
  //Viewers Variables
  showingpdf: boolean = false;
  showpdflink = '';
  pdfloading: boolean = false;

  playingvideo: boolean = false;
  videolink: any = '';
  videoext: any = '';
  showingppt: boolean = false;
  playingYoutubeVideo: boolean = false;
  showingimage: boolean = false;
  showingimagelink: any = '';
  loading: boolean = false;
  youtubeVideoId: string | null = null;
  player: any;
  ytEvent: any;
  videoExtension: any;

  showpptlink: SafeResourceUrl | null = '';


  //Filter fields
  searchApplied: boolean = false;
  ousWithCreatePermission: any[] = [];
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  selectedlink: any = '';
  filters: {
    extension: string | null,
    ou: any,
    date: any,
    search: string | null
  } = {
      extension: null,
      ou: null,
      date: null,
      search: null
    }

  parentOUS = [
    'الوزارات',
    'الجهات المشاركة',
    'كيانات أخرى',
    'وحدة التنظيم',
  ];

  parentOU = 'الجهات المشاركة';


  constructor(
    public dataService: DataService,
    private orgUnitService: OrgUnitsService,
    private http: HttpClient,
    private permissionService: PermissionHandlerService,
    private ouService: OrgUnitsService,
    private domSenitizer: DomSanitizer
  ) { }

  handleSubmit(e: any) {
    e.preventDefault();
  }

  public handleSelect(event: any) {
    this.selectedItem = event;
    this.showDownload = true;
    this.selectedLink = this.selectedItem.link[0];
    this.showitem(this.selectedLink.link);
  }

  downloadCount(i: number) {
    this.kLibrary[i].downloadcount = this.kLibrary[i].downloadcount + 1;
  }

  async ngOnInit() {
    this.getOus().then((e) => {
      this.getData().then((f) => {
        this.getCategories().then((g) => {
          this.preloader = false;
          console.log(this.cat_items, this.ous, this.kLibrary);
        });
      })
    })
  }

  clearSingleFilter(type: string, value: string) {
    this.handleFilter();
  }


  clearFilter() {
    this.filteredData = [];
    this.filters = {
      extension: null,
      ou: null,
      date: null,
      search: null
    }
    this.searchApplied = false;
    this.currentCategory = this.filterCategories[0];
    this.filteredData = this.kLibrary
    this.filteredState = []
    this.filterApplied = false;
    this.updateCategoryCounts(false)
  }

  handleFilter() {
    console.log('FILTERS', this.filters);
    this.filteredData = this.kLibrary.filter((e: any) => {
      if (this.filters.extension) {
        const value = this.filters.extension;
        let found: boolean[] = [];
        for (let link of e.link) {
          if (!!link.link) {
            let splitLink = link?.link?.split('.');
            let ext: string = splitLink[splitLink.length - 1];
            if (value == 'Youtube') {
              if (!ext.includes('com')) {
                found.push(false)
              } else {
                found.push(true)
              }
            } else {
              if (ext != value) {
                found.push(false)
              } else {
                found.push(true);
              }
            }
          }
        }
        if (!found.some(e => e)) {
          return false;
        }
      }

      console.log('BEFORE OU', e)

      if (this.filters.ou) {
        const value: any = this.filters.ou;
        if (value.hasOwnProperty('_id') && e.ou == null) {
          return false;
        } else if (e.ou != null && value._id != e.ou._id) {
          return false;
        }
      }
      console.log('OU PASSED')
      if (this.filters.date) {
        const value: any = this.filters.date;
        if (value[0] != null && value[1] == null) {
          let start = value[0].getTime();
          const createdAt = new Date(e?.createdAt?.split('T')[0]);
          if (createdAt.getTime() < start) {
            return false;
          }
        } else if (value[0] != null && value[1] != null) {
          let start = value[0].getTime();
          let end = value[1].getTime();
          const createdAt = new Date(e?.createdAt?.split('T')[0]);
          if (start == end) {
            if (!(createdAt.getDay() == value[0].getDay() && createdAt.getMonth() == value[0].getMonth() && createdAt.getFullYear() == value[0].getFullYear())) {
              return false;
            }
          }
          else if (createdAt.getTime() < start || createdAt.getTime() > end) {
            return false;
          }
        }
      }
      console.log('DATE PASSED')
      if (this.filters.search) {
        console.log('INSIDE SEARCH')
        const value = this.filters.search.toLowerCase();
        if (value) {
          if (
            !e.name.toLowerCase().includes(value) &&
            !e.description.toLowerCase().includes(value) &&
            !e.categoryname.toLowerCase().includes(value)
          ) {
            return false;
          }
        }
      }
      console.log('SEARCH PASSED', this.filters.search, !!this.filters.search)
      return true;
    });
    console.log('RESULT', this.filteredData)
    this.filterApplied = true;
    this.searchApplied = true;
    this.filteredState = this.filteredData;
    this.currentCategory = null;
    this.updateCategoryCounts(false)
  }

  handleCategoryFilter(value: any) {
    this.currentCategory = value;
    if (value.name == this.translate('ALL')) {
      this.filteredData = this.filteredState.length > 0 ? this.filteredState : this.kLibrary;
      this.filteredState = this.filteredData;
      this.searchApplied = true;
      return;
    }

    let data = this.searchApplied ? this.filteredState : this.kLibrary;
    data = data.filter((e: any) => {
      return e.categoryname == value.name;
    });
    this.filteredData = data;
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  checkarabic(_t36: string) {
    switch (_t36) {
      case 'All':
        return 'الكل';

      default:
        return _t36;
    }
  }

  async getOus() {
    if (this.isLoggedIn) {
      this.ous = await this.permissionService.extractOUChildren('KNOWLEDGE_LIBRARY', 'r');
    } else {
      this.ous = this.permissionService.payload.kLibrary.ou;
    }

  }

  getData = async () => {
    try {
      const res = await this.dataService.getData('knowledge-library');
      if (!res.error) {
        if (this.isLoggedIn) {
          this.kLibrary = res.data.filter((e: any) => {
            if (e.ou == null) {
              if (this.ous.length > 0 && this.parentOU == this.ous[0].label) {
                return true;
              }
              return false;
            } else {
              return this.ouService.childrenContainsId(this.ous, e.ou._id)
            }
          }).reverse();
        } else {
          this.kLibrary = res.data.filter((e: any) => {
            if (e.ou == null) {
              return false;
            } else {
              return this.permissionService.payload.kLibrary.ou.includes(e.ou._id)
            }
          }).reverse();
        }
        this.filteredData = this.kLibrary;
      }
    } catch (error) {
      //console.log(error)
    }
  };

  hasAnyKLibraryPermission() {
    return this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'c') ||
      this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'u') ||
      this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'd')
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getCategories = async () => {
    let allKey = this.translate('ALL');
    this.filterCategories = [{ name: allKey, icon: 'pi pi-file' }];
    try {
      const res = await this.dataService.getData(
        'knowledge-library-category'
      );
      if (!res.error) {
        if (this.isLoggedIn) {
          this.cat_items = res.data
        } else {
          this.cat_items = res.data.filter((c: any) => this.permissionService.payload.kLibrary.categories.includes(c._id));
        }
        this.filterCategories.push(...this.cat_items);
        this.currentCategory = this.filterCategories[0];
        this.categoryCount[allKey] = this.kLibrary.length;
        this.updateCategoryCounts(true)

        console.log("COUNTER", this.categoryCount);

      }

    } catch (error) {
      console.log(error)
    }
  };


  updateCategoryCounts(isInitial: boolean) {
    this.categoryCount = {}
    if (isInitial) {
      this.availableOus = [];
      this.availableExtensions = [];
    }

    this.cat_items.forEach((c: any) => {
      this.filteredData.forEach((k: any) => {
        if (!!k.ou && isInitial) {
          let available = this.availableOus.find(e => e?._id == k?.ou?._id)
          if (!available) {
            this.availableOus.push(k.ou);
          }
        }
        if (c.name == k.categoryname) {
          if (this.categoryCount.hasOwnProperty(c.name)) {
            this.categoryCount[c.name] = this.categoryCount[c.name] + 1;
          } else {
            this.categoryCount[c.name] = 1;
          }
        }
        //Pushing available extensions to a separate array
        isInitial && k?.link.forEach((link: any) => {
          if (!!link?.link) {
            let splitLink = link?.link?.split('.');
            let extension: string = splitLink[splitLink?.length - 1];
            if (extension.includes("com") && !this.availableExtensions.includes("Youtube")) {
              this.availableExtensions.push("Youtube");
            } else if (!this.availableExtensions.includes(extension) && !extension.includes("com")) {
              this.availableExtensions.push(extension);
            }
          }
        });
      });
    });
    let allKey = this.translate('ALL');
    this.categoryCount[allKey] = this.filteredData.length;
  }


  checkExtension(link: string) {
    if (!link) {
      return;
    }
    console.log(link);
    const filename = link.split('/')[link.split('/').length - 1];

    const fileext = filename
      .split('.')
    [filename.split('.').length - 1].toLowerCase();
    return fileext == 'pdf' || fileext == 'ppt' || fileext == '';
  }

  getFileIcon(
    link: string
  ):
    | string
    | string[]
    | Set<string>
    | { [klass: string]: any }
    | null
    | undefined {
    if (!link) {
      return;
    }
    if (link.toLowerCase().includes("youtube")) {
      return "pi pi-video";
    }
    const filename = link.split('/')[link.split('/').length - 1];

    const fileext = filename
      .split('.')
    [filename.split('.').length - 1].toLowerCase();
    this.videoExtension = fileext;

    return this.getFileIconFromExt(fileext);
  }

  getFileIconFromExt(fileext: string) {
    switch (fileext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'psd':
      case 'eps':
      case 'svg':
      case 'ai':
        return 'pi pi-image';

      case 'mp4':
      case 'mov':
      case 'wmv':
      case 'avi':
      case 'avchd':
      case 'mkv':
      case 'webm':
      case 'flv':
        return 'pi pi-video';

      case 'm4a':
      case 'flac':
      case 'mp3':
      case 'wav':
      case 'wma':
      case 'aac':
        return 'pi pi-volume-up';

      case 'zip':
      case 'rar':
        return 'pi pi-briefcase';

      case 'pptx':
      case 'pptm':
      case 'ppt':
        return 'pi pi-file';

      case 'xlsx':
      case 'xlsm':
      case 'csv':
        return 'pi pi-file-excel';

      case 'docx':
      case 'dot':
      case 'dotm':
      case 'txt':
      case 'odt':
        return 'pi pi-file-word';

      case 'pdf':
        return 'pi pi-file-pdf';

      default:
        return 'pi pi-file';
    }
  }

  convertToArabic(item: string, type: string) {
    var itemstring = item + ' ' + type;
    switch (itemstring) {
      case 'All categoryname':
        return 'الكل';
      case 'All userType':
        return 'اختر الجهة الوظيفية';
      case 'All gender':
        return 'اختر الجنس ';
      case 'female gender':
        return 'أنثى';
      case 'male gender':
        return 'ذكر';
      case 'All designation':
        return 'المسمى الوظيفي';
      case 'All department':
        return 'الإدارة';
      case 'All division':
        return 'القسم';
      case 'All branch':
        return 'المقر';
      case 'categoryname T':
        return 'التصنيف';
      case 'userType T':
        return 'اختر الجهة الوظيفية';
      case 'city T':
        return 'اختر المدينة';
      case 'division T':
        return 'القسم';
      case 'department T':
        return 'الإدارة';
      case 'designation T':
        return 'المسمى الوظيفي';
      case 'branch T':
        return 'المقر';
      default:
        return item;
    }
  }


  handleChangeLink(file: any) {
    this.selectedLink = file;
    this.showitem(this.selectedLink.link);
  }

  downloadFile(file: any) {
    this.selectedLink = file;
    this.showitem(this.selectedLink.link);
    let url = this.staticURL + file.link;
    this.http.get(url, { responseType: 'blob' }).subscribe((data: Blob) => {
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(data);
      downloadLink.download = file.name; // Specify the desired file name
      downloadLink.click();
    });
  }

  showimage(link: any) {
    this.showingimage = true;
    this.showingimagelink = link;
  }

  showitem(link: string) {
    link = this.staticURL + link;
    this.showingpdf = false;
    this.playingvideo = false;
    this.showingppt = false;
    this.showingimage = false;
    this.playingYoutubeVideo = false;

    this.selectedlink = link;

    console.log('selection changed', link);
    var link = link;
    switch (this.getFileIcon(link)) {
      case 'pi pi-video':
        this.playvideo(link);
        break;
      case 'pi pi-file-pdf':
        this.showPdf();
        break;
      case 'pi pi-file':
        this.showppt(link);
        break;
      case 'pi pi-image':
        this.showimage(link);
        break;
    }
  }

  onStateChange(event: any) {
    this.ytEvent = event.data;
  }
  savePlayer(player: any) {
    this.player = player;
  }

  playvideo(link: string) {
    if (link.toLowerCase().includes("youtube")) {
      const videoIdMatch = link.match(/[?&]v=([^&]+)/);
      this.youtubeVideoId = videoIdMatch ? videoIdMatch[1] : null;
      this.playingYoutubeVideo = true;
      return;
    }
    this.playingvideo = true;
    this.videolink = link;
    const filename = link.split('/')[link.split('/').length - 1];
    this.videoext = filename
      .split('.')
    [filename.split('.').length - 1].toLowerCase();
  }

  showPdf() {
    this.showingpdf = true;
    return this.domSenitizer.bypassSecurityTrustResourceUrl(GlobalConstants.staticFilesURL + this.selectedLink.link)
  }

  @ViewChild('pptContainer', { static: false }) pptContainer!: ElementRef;

  async showppt(link: string) {
    this.showingppt = true;
    this.loading = true;
    this.pdfloading = true;

    // // Ensure URL is encoded properly
    // const encodedLink = encodeURIComponent(link);
    // const safeUrl = this.domSenitizer.bypassSecurityTrustResourceUrl(
    //   `https://docs.google.com/gview?url=${encodedLink}&embedded=true`
    // );

    // this.showpptlink = safeUrl;

    // var selector = document.querySelector('iframe');
    // if (selector != null)
    //   selector.src = '//docs.google.com/gview?url=' + link + '&embedded=true';


    this.loading = false;
    this.pdfloading = false;
  }

  download(link: string, name: string) {
    this.loading = true;
    this.http.get(link).subscribe((response: any) => {
      let blob: any = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      //window.open(url);
      saveAs(blob, name);
      this.loading = false;
    }),
      (error: any) => console.log('Error downloading the file'),
      () => {
        console.info('File downloaded successfully');
      };
  }
}

export interface knowledge_item {
  _id: any;
  createdAt: string;
  name: string;
  description: string;
  image: string;
  categoryname: string;
  categoryicon: string;
  link: any[];
  downloadcount: number;
  entity?: string;
}

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}
